import './App.css';
import StopWatch from './stopWatch/stopWatch'

function App() {
  return (
    <div className="App">
      <StopWatch />
    </div>
  );
}

export default App;
